import React, { useEffect, useRef } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const TextEditor = (props) => {
  const {
    text,
    setText,
    showToolbar = true,
    readOnly = false,
    onEditorReady,
    minHeight,
  } = props;
  const editorRef = useRef(null);
  const skipNextChangeRef = useRef(false);

  useEffect(() => {
    const editor = editorRef.current;
    if (!editor) return;

    const next = text || "";
    if (editor.getData() === next) return;

    skipNextChangeRef.current = true;
    editor.setData(next);
  }, [text]);

  return (
    <div
      style={{
        pointerEvents: readOnly ? "none" : "auto",
        borderRadius: "8px",
        borderWidth: "1px",
      }}
    >
      <CKEditor
        editor={ClassicEditor}
        data={text || ""}
        disabled={readOnly}
        config={{
          contentsCss: "index.css",
          toolbar: showToolbar
            ? [
                "heading",
                "|",
                "bold",
                "italic",
                "link",
                "bulletedList",
                "numberedList",
                "blockQuote",
                "insertTable",
                "undo",
                "redo",
              ]
            : [],
          heading: {
            options: [
              {
                model: "paragraph",
                title: "Paragraph",
                class: "ck-heading_paragraph",
              },
              {
                model: "heading1",
                view: "h1",
                title: "Heading 1",
                class: "ck-heading_heading1",
              },
              {
                model: "heading2",
                view: "h2",
                title: "Heading 2",
                class: "ck-heading_heading2",
              },
              {
                model: "heading3",
                view: "h3",
                title: "Heading 3",
                class: "ck-heading_heading3",
              },
            ],
          },
          table: {
            contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
          },
        }}
        onReady={(editor) => {
          editorRef.current = editor;
          if (minHeight) {
            editor.editing.view.change((writer) => {
              writer.setStyle(
                "min-height",
                typeof minHeight === "number" ? `${minHeight}px` : minHeight,
                editor.editing.view.document.getRoot()
              );
            });
          }
          const next = text || "";
          if (next && editor.getData() !== next) {
            skipNextChangeRef.current = true;
            editor.setData(next);
          }
          if (typeof onEditorReady === "function") {
            onEditorReady(editor);
          }
        }}
        onChange={(event, editor) => {
          if (skipNextChangeRef.current) {
            skipNextChangeRef.current = false;
            return;
          }
          setText(editor.getData());
        }}
      />
    </div>
  );
};

export default TextEditor;
